export default "<p>\r\n  view works!\r\n</p>\r\n"